import PageShell from "@/components/founding/PageShell";
import Testimonials from "@/components/founding/Testimonials";

export default function TestimonialsPage() {
    return (
        <PageShell>
            <Testimonials />
        </PageShell>
    );
}
